import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledEnrichmentToggleWrapperFlex = styled(Flex)`
    border-top: 1px solid ${colorsPalettes.carbon[50]};
    padding: 25px 0;
`;

export const StyledEnrichmentToggle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const StyledEnrichmentSwitchContainer = styled.div`
    display: flex;
`;

export const StyledEnrichmentJobNameWrapper = styled(Flex)`
    align-items: center;
    margin-left: 5px;
    gap: 8px;
`;

export const StyledEnrichmentJobLabel = styled.div`
    ${setFontVariant("body1")};
    color: ${colorsPalettes.carbon[400]};
    text-transform: capitalize;
    line-height: 20px;
`;

export const StyledEnrichmentJobInfo = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
`;

export const StyledEnrichmentJobType = styled.div`
    padding: 4px 8px;
    border-radius: 26px;
    background-color: ${colorsPalettes.blue[100]};
    ${setFontVariant("tab", colorsPalettes.carbon[400])};
    font-size: 12px;
`;

export const StyledEnrichmentJobObject = styled(StyledEnrichmentJobType)`
    background-color: ${colorsPalettes.bluegrey[200]};
    color: ${colorsPalettes.bluegrey[600]};
`;

export const StyledEnrichmentJobTypeDivider = styled.div`
    width: 1px;
    height: 14px;
    background-color: ${colorsPalettes.carbon[100]};
`;
